<template>
  <div>
    <div class="dashboard-title mb-lg">
      <BackButton link="/reviews" text="Back to Reviews" />
      <div class="dashboard-title__actions">
        <h1 class="fw-bold fc-darkest fs-xl mb-xs">
          {{ reviewDetail.resellerName }} Review
        </h1>
        <div>
          <Button
            v-on:button-click="
              changeReviewStatus({ id: reviewDetail.id, val: 'D' })
            "
            v-if="reviewDetail.status !== 'D'"
            bType="error"
            style="margin-right: 8px;"
          >
            Decline
          </Button>
          <Button
            v-on:button-click="
              changeReviewStatus({ id: reviewDetail.id, val: 'A' })
            "
            v-if="reviewDetail.status !== 'A'"
          >
            Approve
          </Button>
        </div>
      </div>
    </div>
    <hr class="mb-lg" />
    <div class="grid grid--rev">
      <div class="grid__cell col5-of-12--large-up"></div>
      <div class="grid__cell col7-of-12--large-up">
        <div class="grid">
          <div>
            <div class="grid__cell col6-of-12--large-up mb-sm">
              <p class="f-capitalize theme-text-dark fw-bold fs-md mb-xs">
                status:
              </p>
              <p class="fs-sm theme-text-medium">
                {{ reviewDetail.status | status }}
              </p>
            </div>
            <div class="grid__cell col6-of-12--large-up mb-sm">
              <p class="f-capitalize theme-text-dark fw-bold fs-md mb-xs">
                agency:
              </p>
              <p class="fs-sm theme-text-medium">
                {{ reviewDetail.resellerName }}
              </p>
            </div>
            <div class="grid__cell col6-of-12--large-up mb-sm">
              <p class="theme-text-dark fw-bold fs-md mb-xs">Review date:</p>
              <p class="fs-sm theme-text-medium">{{ date }}</p>
            </div>
            <div class="grid__cell col6-of-12--large-up mb-sm">
              <p class="theme-text-dark fw-bold fs-md mb-xs">Review rating:</p>
              <span>
                <i
                  v-for="(star, i) in reviewDetail.rating"
                  :key="i"
                  class="fs-xl fa fa-star star-fill fs-lg mr-xxs"
                ></i>
              </span>
            </div>
            <div class="grid__cell col6-of-12--large-up mb-sm">
              <p class="theme-text-dark fw-bold fs-md mb-xs">Review title:</p>
              <p class="fs-sm theme-text-medium">{{ reviewDetail.title }}</p>
            </div>
            <div class="grid__cell col6-of-12--large-up mb-sm">
              <p class="theme-text-dark fw-bold fs-md mb-xs">Submitted by:</p>
              <p class="fs-sm theme-text-medium">{{ name }}</p>
              <p class="fs-sm theme-text-medium">{{ reviewDetail.email }}</p>
            </div>
            <div class="grid__cell">
              <p class="theme-text-dark fw-bold fs-md mb-xs">Review summary:</p>
              <p class="fs-sm theme-text-medium format">
                {{ reviewDetail.summary }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate } from '@/utils/date';
import { createNamespacedHelpers } from 'vuex';
import Button from '@/components/DesignSystem/Button';
import BackButton from '@/components/BackButton';
const { mapGetters, mapActions } = createNamespacedHelpers('reviews/detail');

export default {
  name: 'ReviewDetail',
  filters: {
    status(value) {
      switch (value) {
        case 'P':
          return 'Pending';
        case 'A':
          return 'Approved';
        case 'D':
          return 'Declined';
      }
    },
  },
  components: {
    Button,
    BackButton,
  },
  computed: {
    ...mapGetters(['reviewDetail']),
    name() {
      return this.reviewDetail.firstName + ' ' + this.reviewDetail.lastName;
    },
    date() {
      return this.reviewDetail.created
        ? formatDate(new Date(this.reviewDetail.created))
        : '';
    },
  },
  methods: {
    ...mapActions(['fetchReviewDetail', 'changeReviewStatus']),
  },
  created() {
    this.fetchReviewDetail(this.$route.params.id);
  },
};
</script>

<style lang="scss" scoped>
.grid .grid__cell {
  margin-bottom: 1.25em;

  .f-capitalize {
    margin-bottom: 0.33em;
  }
}
</style>
